import { useAuthContext } from "@/contexts/AuthContext";
import { useApi } from "@/hooks/useApi";
import { useQuery } from "@tanstack/react-query";

export const useCreditsHistory = () => {
  const api = useApi();
  const { user } = useAuthContext();
  return useQuery({
    queryKey: ["creditsHistory"],
    queryFn: async () => {
      return await api.getCreditsHistory();
    },
    enabled: !!user?.userId,
  });
};
